import request from '@/utils/request'


// 查询日常、打卡动态列表
export function listInfo(query) {
  return request({
    url: '/dynamics/info/list',
    method: 'get',
    params: query
  })
}

// 查询日常、打卡动态分页
export function pageInfo(query) {
  return request({
    url: '/dynamics/info/page',
    method: 'get',
    params: query
  })
}

// 查询日常、打卡动态详细
export function getInfo(data) {
  return request({
    url: '/dynamics/info/detail',
    method: 'get',
    params: data
  })
}

// 新增日常、打卡动态
export function addInfo(data) {
  return request({
    url: '/dynamics/info/add',
    method: 'post',
    data: data
  })
}

// 修改日常、打卡动态
export function updateInfo(data) {
  return request({
    url: '/dynamics/info/edit',
    method: 'post',
    data: data
  })
}

export function editTop(data) {
  return request({
    url: '/dynamics/info/editTop',
    method: 'post',
    data: data
  })
}
// 删除日常、打卡动态
export function delInfo(data) {
  return request({
    url: '/dynamics/info/delete',
    method: 'post',
    data: data
  })
}
